import { Advert, CatalogWarning, CatalogModeration, WarningTarget } from "./types";

export function warningTarget(advert: Advert, type: WarningTarget["type"]): WarningTarget | null {
  if (type === "merchant") {
    const sellerName = advert.seller?.name?.trim();
    return sellerName ? { type, sellerName } : null;
  }
  return advert.sourceName && advert.sourceId != null && String(advert.sourceId).trim()
    ? { type, sourceName: advert.sourceName, sourceId: String(advert.sourceId) }
    : null;
}

export function warningKey(target: WarningTarget): string {
  return target.type === "merchant"
    ? `merchant:${target.sellerName?.trim().toLowerCase()}`
    : `ad:${target.sourceName}:${target.sourceId}`;
}

export function currentWarning(advert: Advert, type: WarningTarget["type"], moderation: CatalogModeration): CatalogWarning | undefined {
  const target = warningTarget(advert, type);
  return target ? moderation[warningKey(target)] : undefined;
}
